export default __webpack_public_path__ + "static/media/benefit4_large.d542081c.png";